// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/header-background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/invitation-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
}

.header {
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: cover;
}
.header .navbar {
  transition: all 0.5s ease-in-out;
}

@media (max-width: 991px) {
  .navbar-nav {
    margin-left: 5.5%;
  }
}
#register-form,
#discover-1,
#summary,
#takeaways,
#subscribe {
  scroll-margin-top: 150px !important;
}

.invitation {
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
  background-size: cover;
}

.fa-stack-2x {
  color: #f8f5ee;
}

.footer-socials i:hover {
  color: var(--bs-primary) !important;
}

@media (max-width: 569px) {
  #register-form,
  #discover-1,
  #summary,
  #takeaways,
  #subscribe {
    scroll-margin-top: 90px !important;
  }
}
@media (max-width: 767px) {
  .hero-content .btn {
    padding: 0.8rem 1.5rem;
    font-size: 0.875rem;
  }
  .invitation .btn {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
  }
}
@media (max-width: 645px) {
  .carousel img {
    height: 230px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .carousel img {
    height: 350px;
  }
}
@media (min-width: 571px) and (max-width: 680px) {
  .takeaways .wrapper {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (min-width: 681px) and (max-width: 767px) {
  .takeaways .wrapper {
    width: 65%;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (orientation: landscape) and (max-height: 600px) {
  .container-lg,
  .container-xl {
    width: 85%;
  }
  #invitation .container-lg {
    width: 100%;
  }
  .hero-content .pt-7 {
    padding-top: 4rem !important;
  }
  #discover-1,
  #summary,
  #takeaways,
  #subscribe {
    scroll-margin-top: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;AADF;;AAKA;EACE,oIAAA;EAEA,sBAAA;AAHF;AAKE;EACE,gCAAA;AAHJ;;AAQA;EACE;IACE,iBAAA;EALF;AACF;AASA;;;;;EAKE,mCAAA;AAPF;;AAWA;EACE,oIAAA;EAEA,sBAAA;AATF;;AAaA;EACE,cAAA;AAVF;;AAeE;EACE,mCAAA;AAZJ;;AAkBA;EACE;;;;;IAKE,kCAAA;EAfF;AACF;AAkBA;EACE;IACE,sBAAA;IACA,mBAAA;EAhBF;EAkBA;IACE,sBAAA;IACA,eAAA;EAhBF;AACF;AAoBA;EACE;IACE,aAAA;EAlBF;AACF;AAoBA;EACE;IACE,aAAA;EAlBF;AACF;AAsBA;EAEI;IACE,UAAA;IACA,iBAAA;IACA,kBAAA;EArBJ;AACF;AAyBA;EAEI;IACE,UAAA;IACA,iBAAA;IACA,kBAAA;EAxBJ;AACF;AA6BA;EACE;;IAEE,UAAA;EA3BF;EA6BA;IACE,WAAA;EA3BF;EA8BA;IACE,4BAAA;EA5BF;EAgCA;;;;IAIE,+BAAA;EA9BF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n// -----------------\nbody {\n  overflow-x: hidden;\n}\n\n// Header\n.header {\n  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),\n    url(../assets/images/header-background.jpg) center center no-repeat;\n  background-size: cover;\n\n  .navbar {\n    transition: all 0.5s ease-in-out;\n  }\n}\n\n// nav links under the logo effect\n@media (max-width: 991px) {\n  .navbar-nav {\n    margin-left: calc(5.5%);\n  }\n}\n\n// handling Scrolling & navbar position\n#register-form,\n#discover-1,\n#summary,\n#takeaways,\n#subscribe {\n  scroll-margin-top: 150px !important;\n}\n\n// Invitation\n.invitation {\n  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),\n    url(../assets/images/invitation-background.jpg) center center no-repeat;\n  background-size: cover;\n}\n\n// Takeaways\n.fa-stack-2x {\n  color: darken(#fbf9f5, 2%);\n}\n\n// Footer\n.footer-socials {\n  i:hover {\n    color: var(--bs-primary) !important;\n  }\n}\n\n// Media Queries ----------------------\n// Under sm breakpoint\n@media (max-width: 569px) {\n  #register-form,\n  #discover-1,\n  #summary,\n  #takeaways,\n  #subscribe {\n    scroll-margin-top: 90px !important;\n  }\n}\n// Under md breakpoint\n@media (max-width: 767px) {\n  .hero-content .btn {\n    padding: 0.8rem 1.5rem;\n    font-size: 0.875rem;\n  }\n  .invitation .btn {\n    padding: 0.8rem 1.5rem;\n    font-size: 1rem;\n  }\n}\n\n// Carousel ---------------\n@media (max-width: 645px) {\n  .carousel img {\n    height: 230px;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .carousel img {\n    height: 350px;\n  }\n}\n\n// Takeaways -------------\n@media (min-width: 571px) and (max-width: 680px) {\n  .takeaways {\n    .wrapper {\n      width: 80%;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n}\n\n@media (min-width: 681px) and (max-width: 767px) {\n  .takeaways {\n    .wrapper {\n      width: 65%;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n}\n\n// Mobile Landscape Mode ----------\n@media (orientation: landscape) and (max-height: 600px) {\n  .container-lg,\n  .container-xl {\n    width: 85%;\n  }\n  #invitation .container-lg {\n    width: 100%;\n  }\n\n  .hero-content .pt-7 {\n    padding-top: 4rem !important;\n  }\n\n  // handling Scrolling & navbar position\n  #discover-1,\n  #summary,\n  #takeaways,\n  #subscribe {\n    scroll-margin-top: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
